import { Box, Container, Grid } from "@mui/material";
import { StyledHeadingWithGradientunderline } from "@Styled/Pages/Landing/Category";
import {
  StyledContent,
  StyledGridContainer,
  StyledTitle,
} from "@Styled/Pages/Prefooter";

const ShippingPolicy = () => {
  return (
    <>
      <Container sx={{ marginBottom: "5rem" }}>
        <StyledGridContainer container>
          <StyledHeadingWithGradientunderline
            variant="subtitle1"
            sx={{
              fontSize: { sm: "1.5rem", xs: "1.2rem" },
              letterSpacing: "-1px",
            }}
          >
            Shipping Policy{" "}
          </StyledHeadingWithGradientunderline>
          <Grid item sm={12} style={{ marginTop: "1rem", display: "flex" }}>
            <ol>
              <li style={{ fontSize: "1.1rem", padding: "0.3rem 1rem" }}>
                All orders will be dispatched within 48-72 working hours from
                our warehouse.
              </li>
              <li style={{ fontSize: "1.1rem", padding: "0.3rem 1rem" }}>
                Orders placed in festive seasons, sale & offer period might get
                delayed. While we try our best to dispatch at the earliest, we
                request you to cooperate with us for the same.
              </li>
              <li style={{ fontSize: "1.1rem", padding: "0.3rem 1rem" }}>
                Orders placed on Saturdays & Sundays will be dispatched within
                48-72 hours from the next working day.
              </li>
              <li style={{ fontSize: "1.1rem", padding: "0.3rem 1rem" }}>
                Free shipping is available on all products, subject to a minimum
                order value of Rs. 399/-. A Non-Refundable charge of Rs. 100/-
                will be applied to all orders below Rs. 399/-
              </li>
              <li style={{ fontSize: "1.1rem", padding: "0.3rem 1rem" }}>
                The whole order amount including any delivery charges will be
                refunded if the order is cancelled or lost in transit by us.{" "}
              </li>
            </ol>
          </Grid>
        </StyledGridContainer>
        <StyledTitle>Delivery Queries</StyledTitle>
        <StyledContent>
          {" "}
          Check your delivery status of your order by logging in your my econut
          account at link. If you still have query please call our customer Care
          Team on{" "}
          <a href="tel:+91-85913 67993" style={{ color: "#00844a" }}>
            +91-85913 67993
          </a>
          (Working hours: Monday to Saturday, 10:00 am to 06:30 pm) or email us
          at{" "}
          <a
            href="mailto: customercare@econut.store"
            style={{ color: "#00844a" }}
          >
            customercare@econut.store
          </a>
        </StyledContent>
      </Container>
    </>
  );
};
export default ShippingPolicy;
